import { Minus, Plus } from 'lucide-react';
import cn from 'classnames';
import i18n from '@/settings/i18n';

const t = i18n.init('cart');

const BUTTON =
  'flex h-6 w-6 shrink-0 items-center justify-center rounded-full shadow bg-white text-gray-700 transition duration-150 ease-in-out enabled:hover:border-gray-700 disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none';

const QuantityStepper = ({
  quantity,
  max,
  disabled = false,
  onChange,
}: {
  quantity: number;
  max?: number;
  disabled?: boolean;
  onChange: (quantity: number) => void | Promise<void>;
}) => (
  <div
    className="flex items-center gap-2 rounded-full bg-[#F2F4F7] p-1"
    data-testid="quantity-stepper"
  >
    <button
      type="button"
      className={BUTTON}
      disabled={disabled}
      aria-label={t`Decrease quantity`}
      onClick={() => onChange(quantity - 1)}
    >
      <Minus className="h-3.5 w-3.5" />
    </button>
    <span
      className={cn('min-w-[1ch] text-center text-sm font-medium', {
        'opacity-50': disabled,
      })}
      translate="no"
      aria-live="polite"
    >
      {quantity}
    </span>
    <button
      type="button"
      className={BUTTON}
      disabled={disabled || (max != null && quantity >= max)}
      aria-label={t`Increase quantity`}
      onClick={() => onChange(quantity + 1)}
    >
      <Plus className="h-3.5 w-3.5" />
    </button>
  </div>
);

export default QuantityStepper;
